import React from "react";

import { cn } from "@/utils/cn";

export interface IDotProps {
	color: string;
	className?: string;
	square?: boolean;
}

export const Dot: React.FC<IDotProps> = ({
	color,
	className,
	square = false,
}) => {
	return (
		<div
			style={{
				backgroundColor: color,
			}}
			className={cn([
				"h-3 w-3 min-w-3",
				square ? "rounded-xs" : "rounded-full",
				className,
			])}
		/>
	);
};
